// extracted by mini-css-extract-plugin
export var arrows = "_6j-5";
export var decrementer = "_6j-9";
export var disabled = "_6j-3";
export var error = "_6j-1";
export var hiddenText = "_6j-a";
export var incrementer = "_6j-8";
export var input = "_6j-7";
export var inputWrapper = "_6j-0";
export var leadingIcon = "_6j-b";
export var readonly = "_6j-2";
export var regular = "_6j-6";
export var small = "_6j-4";